import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

export default function Loading(props) {
  const { loading } = props;
  return loading ? (
    <div className="sweet-loading">
      <ScaleLoader
        css="width: 40px;height: 40px;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;"
        size={150}
        color={"#123abc"}
        loading={loading}
      />
    </div>
  ) : (
    ""
  );
}
